<div class="register-page">

  <div class="register-container">

    <!-- ABAS -->

    <div class="tabs">

      <button
        type="button"
        class="tab-button"
        [class.active]="activeTab === 'LIST'"
        (click)="activeTab = 'LIST'"
      >
        Usuários
      </button>

      <button
        type="button"
        class="tab-button"
        [class.active]="activeTab === 'FORM'"
        (click)="activeTab = 'FORM'"
      >
        Cadastro
      </button>

    </div>

    <!-- LISTAGEM -->

    <div
      class="users-list"
      *ngIf="activeTab === 'LIST'"
    >

      <div class="list-header">

        <h2>
          Usuários Cadastrados
        </h2>

        <button
          type="button"
          class="new-user-button"
          (click)="newUser()"
        >

          + Novo Usuário

        </button>

      </div>

      <table>

        <thead>

          <tr>

            <th>Nome</th>

            <th>Email</th>

            <th>Telefone</th>

            <th>Perfil</th>

            <th>Ações</th>

          </tr>

        </thead>

        <tbody>

          <tr
            *ngFor="let user of users"
          >

            <td>
              {{ user.name }}
            </td>

            <td>
              {{ user.email }}
            </td>

            <td>
              {{ user.phone }}
            </td>

            <td>
              {{ user.role }}
            </td>

            <td class="actions-column">

              <button
                type="button"
                class="edit-button"
                (click)="editUser(user)"
              >

                Editar

              </button>

              <button
                type="button"
                class="delete-button"
                (click)="deleteUser(user.id)"
              >

                Excluir

              </button>

            </td>

          </tr>

          <tr *ngIf="users.length === 0">

            <td
              colspan="5"
              class="empty-table"
            >

              Nenhum usuário encontrado.

            </td>

          </tr>

        </tbody>

      </table>

    </div>

    <!-- FORMULÁRIO -->

    <div *ngIf="activeTab === 'FORM'">

      <div class="register-header">

        <h1>

          {{
            editingUserId
              ? 'Editar Usuário'
              : 'Cadastro de Usuário'
          }}

        </h1>

        <p>

          {{
            editingUserId
              ? 'Atualize os dados do usuário'
              : 'Preencha os dados para criar uma nova conta'
          }}

        </p>

      </div>

      <form
        [formGroup]="userForm"
        (ngSubmit)="onSubmit()"
      >

        <div class="form-grid">

          <div class="form-group">

            <label for="name">
              Nome Completo
            </label>

            <input
              id="name"
              type="text"
              formControlName="name"
              placeholder="Digite o nome completo"
            />

          </div>

          <div class="form-group">

            <label for="email">
              E-mail
            </label>

            <input
              id="email"
              type="email"
              formControlName="email"
              placeholder="Digite o e-mail"
            />

          </div>

          <div class="form-group">

            <label for="phone">
              Telefone
            </label>

            <input
              id="phone"
              type="text"
              formControlName="phone"
              placeholder="(00) 00000-0000"
            />

          </div>

          <div class="form-group">

            <label for="cpf">
              CPF
            </label>

            <input
              id="cpf"
              type="text"
              formControlName="cpf"
              placeholder="000.000.000-00"
            />

          </div>

          <div class="form-group">

            <label for="password">
              Senha
            </label>

            <input
              id="password"
              type="password"
              formControlName="password"
              placeholder="Digite a senha"
            />

          </div>

          <div class="form-group">

            <label for="confirmPassword">
              Confirmar Senha
            </label>

            <input
              id="confirmPassword"
              type="password"
              formControlName="confirmPassword"
              placeholder="Confirme a senha"
            />

          </div>

        </div>

        <div class="form-group full-width">

          <label for="role">
            Perfil
          </label>

          <select
            id="role"
            formControlName="role"
          >

            <option value="">
              Selecione
            </option>

            <option value="ADMIN">
              Administrador
            </option>

            <option value="USER">
              Usuário
            </option>

            <option value="MANAGER">
              Gerente
            </option>

          </select>

        </div>

        <div class="checkbox-group">

          <input
            id="terms"
            type="checkbox"
            formControlName="terms"
          />

          <label for="terms">

            Aceito os termos e condições

          </label>

        </div>

        <div class="actions">

          <button
            type="button"
            class="cancel-button"
            (click)="cancel()"
          >

            Cancelar

          </button>

          <button
            type="submit"
            class="save-button"
            [disabled]="userForm.invalid || loading"
          >

            <span *ngIf="!loading">

              {{
                editingUserId
                  ? 'Atualizar Usuário'
                  : 'Cadastrar Usuário'
              }}

            </span>

            <span *ngIf="loading">

              Salvando...

            </span>

          </button>

        </div>

      </form>

    </div>